import { products } from "../data/products.json";

const productsFromLocalStorage = JSON.parse(
  localStorage.getItem("productsInCart") || "[]"
);
// console.log(productsFromLocalStorage);
let totalPriceFromLocalStorage = 0;
let totalAmountFromLocalStorage = 0;

for (let i = 0; i < productsFromLocalStorage.length; i++) {
  // console.log(totalPriceFromLocalStorage);

  totalAmountFromLocalStorage +=
    Math.floor(
      parseInt(productsFromLocalStorage[i].pPrice) *
        ((100 - productsFromLocalStorage[i].pOffer) / 100)
    ) * productsFromLocalStorage[i].quantity;
  // console.log(totalPriceFromLocalStorage);
}

for (let i = 0; i < productsFromLocalStorage.length; i++) {
  // console.log(totalPriceFromLocalStorage);

  totalPriceFromLocalStorage +=
    parseInt(productsFromLocalStorage[i].pPrice) *
    productsFromLocalStorage[i].quantity;
  // console.log(totalPriceFromLocalStorage);
}

var totalQuantityFromLocalStorage = 0;
for (let i = 0; i < productsFromLocalStorage.length; i++) {
  totalQuantityFromLocalStorage += productsFromLocalStorage[i].quantity;
}

const ordersFromLocalStorage = JSON.parse(
  localStorage.getItem("recentOrder") || "[]"
);
// console.log(ordersFromLocalStorage);

const my_orders = JSON.parse(localStorage.getItem("myOrders") || "[]");

const initialState = {
  products: products,
  cartProducts: productsFromLocalStorage,
  totalPrice: totalPriceFromLocalStorage,
  totalQuantities: totalQuantityFromLocalStorage,
  recentOrder: ordersFromLocalStorage,
  myOrders: my_orders,
  totalAmount: totalAmountFromLocalStorage,
};

const cartReducer = (state = initialState, action) => {
  let findPro;
  let index;
  switch (action.type) {
    case "ADD_TO_CART":
      const { product, quantity } = action.payload;
      // console.log(state.totalAmount,state.totalPrice);
      var check = false;
      check = check || state.cartProducts.find((pr) => pr._id === product._id);
      if (check) {
        return state;
      } else {
        // console.log(state.totalPrice,0,typeof(0),typeof(totalPriceFromLocalStorage),typeof(state.totalPrice));
        const Tamount =
          state.totalAmount +
          Math.floor(
            parseInt(product.pPrice) * ((100 - product.pOffer) / 100)
          ) *
            quantity;
        const Tprice =
          state.totalPrice +
          Math.floor(
            parseInt(product.pPrice) * ((100 - product.pOffer) / 100)
          ) *
            quantity;
        // console.log(Tprice,state.totalAmount);
        // console.log(state.totalPrice,Tprice,parseInt(product.pricing[0].price) * quantity);
        const Tquantities = state.totalQuantities + quantity;
        product.quantity = quantity;
        return {
          ...state,
          cartProducts: [...state.cartProducts, product],
          totalAmount: Tamount,
          totalPrice: Tprice,
          totalQuantities: Tquantities,
        };
      }
    case "INC":
      findPro = state.cartProducts.find(
        (product) => product._id === action.payload
      );
      index = state.cartProducts.findIndex(
        (product) => product._id === action.payload
      );
      findPro.quantity += 1;
      state.cartProducts[index] = findPro;
      return {
        ...state,
        totalAmount:
          state.totalAmount +
          Math.floor(parseInt(findPro.pPrice) * ((100 - findPro.pOffer) / 100)),
        totalQuantities: state.totalQuantities + 1,
        totalPrice: state.totalPrice + parseInt(findPro.pPrice),
      };
    case "DEC":
      findPro = state.cartProducts.find(
        (product) => product._id === action.payload
      );
      index = state.cartProducts.findIndex(
        (product) => product._id === action.payload
      );
      if (findPro.quantity > 1) {
        findPro.quantity -= 1;
        state.cartProducts[index] = findPro;
        return {
          ...state,
          totalAmount:
            state.totalAmount -
            Math.floor(
              parseInt(findPro.pPrice) * ((100 - findPro.pOffer) / 100)
            ),
          totalQuantities: state.totalQuantities - 1,
          totalPrice: state.totalPrice - parseInt(findPro.pPrice),
        };
      } else {
        return state;
      }
    case "LOAD_CART":
      // const {cart} = action.payload
      return {
        ...state,
        totalAmount: 0,
        totalQuantities: 0,
        myOrders: [],
        recentOrder: [],

        cartProducts: [],
      };
    case "REMOVE":
      findPro = state.cartProducts.find(
        (product) => product._id === action.payload
      );
      const filtered = state.cartProducts.filter(
        (product) => product._id !== action.payload
      );
      return {
        ...state,
        cartProducts: filtered,
        // totalAmount:
        //   state.totalAmount - parseInt(findPro.price) * findPro.quantity,
        totalAmount:
          state.totalAmount -
          parseInt(findPro.pPrice) *
            ((100 - findPro.pOffer) / 100) *
            findPro.quantity,
        totalPrice:
          state.totalPrice -
          parseInt(findPro.pPrice) *
            ((100 - findPro.pOffer) / 100) *
            findPro.quantity,
        totalQuantities: state.totalQuantities - findPro.quantity,
      };
    case "EMPTY_CART":
      const a = state.myOrders;
      a.push(action.payload);
      localStorage.setItem("myOrders", JSON.stringify(a));
      return {
        ...state,
        // myOrders: allOrders,
        cartProducts: [],
        totalAmount: 0,
        totalPrice: 0,
        totalQuantities: 0,
        recentOrder:[]
      };

    default:
      return state;
  }
};
export default cartReducer;
